import { AppConfig } from '@ltvco/refresh-lib/ctx';
import {
  Button,
  Card,
  CardActionArea,
  Stack,
  Text,
} from '@ltvco/refresh-lib/theme';
import { Check } from '@mui/icons-material';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import BumperLogoMark from 'images/bumper_showroom_cta_image.svg';

const FEATURES = [
  'Post your car in just minutes',
  'Reach serious buyers faster',
  'Showcase your car with trusted history data',
  'Manage your listing in one easy spot',
];

/**
 * In-feed marketplace ad promoting Bumper Showroom (listing your own car),
 * ported from the Ember `ads/bumper-showroom-ad` component. Spliced into the
 * results grid via `ResultsGrid`'s `adSlots`; navigates to the sell-your-car
 * page on click.
 *
 * Skips Ember's decorative bottom car-illustration graphic
 * (`showroom-graphic.png`) — no equivalent asset exists in this brand.
 */
export function BumperShowroomAd() {
  const navigate = useNavigate();
  const { trackEvent } = useContext(AppConfig);

  const handleClick = () => {
    trackEvent('Sell Your Car', 'Click', 'In-feed marketplace ad');
    navigate('/marketplace/sell-your-car');
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardActionArea
        onClick={handleClick}
        aria-label="Learn more about Bumper Showroom"
        sx={{ height: '100%', p: 2 }}
      >
        <Stack spacing={1.5} height="100%" alignItems="center">
          <img src={BumperLogoMark} alt="" width={49} height={44} />
          <Text variant="h6" fontWeight={600} textAlign="center">
            Sell your car smarter
          </Text>
          <Stack spacing={0.75} alignSelf="stretch">
            {FEATURES.map((feature) => (
              <Stack
                key={feature}
                direction="row"
                spacing={1}
                alignItems="flex-start"
              >
                <Check color="primary" sx={{ fontSize: '1rem', mt: 0.25 }} />
                <Text variant="body2">{feature}</Text>
              </Stack>
            ))}
          </Stack>
          {/* Rendered as a div, not a button: the whole card is already the
              clickable CardActionArea, and a real button here would nest
              interactive controls (invalid HTML, breaks a11y semantics). */}
          <Button
            component="div"
            variant="contained"
            fullWidth
            sx={{ borderRadius: 999, mt: 'auto', pointerEvents: 'none' }}
          >
            List your car for sale now
          </Button>
        </Stack>
      </CardActionArea>
    </Card>
  );
}
